import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useState, } from 'react';
import OtpCountdown from './components/OtpCountdown';
import DInputPin from '../DInputPin';
import DButton from '../DButton';
const TEXT_PROPS = {
    resend: 'Resend',
    resendText: 'Resend code',
    submit: 'Authorize and continue',
    title: 'We will send you a 6-digit code to your associated phone number so you can continue with your request.',
    contact: (_jsxs(_Fragment, { children: [_jsx("span", { children: "Problems with your digital token? Contact us" }), ' ', _jsx("a", { href: "https://www.modyo.com", className: "link-primary text-nowrap", target: "_blank", rel: "noreferrer", children: "Contact us" })] })),
};
export default function DOtp({ className, action, isLoading, otpSize = 6, texts = TEXT_PROPS, seconds = 15, }) {
    const [otp, setOtp] = useState('');
    const [invalid, setInvalid] = useState(false);
    const handler = useCallback(async () => {
        if (otp.length < otpSize) {
            setInvalid(true);
            return;
        }
        setInvalid(false);
        await action();
    }, [
        otp.length,
        action,
        otpSize,
    ]);
    return (_jsxs("div", { className: className, children: [_jsx("p", { children: texts.title }), _jsxs("div", { className: "d-flex flex-column gap-6 pb-4 px-3", children: [_jsxs("div", { className: "d-flex flex-column gap-6", children: [_jsx(DInputPin, { className: "modal-otp-pin", characters: otpSize, onChange: (e) => setOtp(e), invalid: invalid && otp.length < otpSize, placeholder: "0" }), _jsx(OtpCountdown, { seconds: seconds, resendText: texts.resend })] }), _jsx("hr", { className: "m-0" }), _jsxs("div", { className: "d-flex flex-column flex-lg-row gap-4 align-items-center", children: [_jsx(DButton, { text: texts.submit, onClick: () => {
                                    handler().catch((err) => {
                                        // eslint-disable-next-line no-console
                                        console.error('Error in DOtp action:', err);
                                    });
                                }, loading: isLoading }), _jsx("p", { className: "small ms-lg-auto mb-0", children: texts.contact })] })] })] }));
}
//# sourceMappingURL=DOtp.js.map